// extracted by mini-css-extract-plugin
export var footer = "_nt-5";
export var fulfillmentInput = "_nt-0";
export var shipDateInput = "_nt-1";
export var shipmentModal = "_nt-2";
export var shipmentModalContent = "_nt-3";
export var tableContainer = "_nt-4";